// extracted by mini-css-extract-plugin
export default {"searchBox":"Merchant_searchBox__Bn7H2"};